import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        // Toolbar Posison
        toolbarActivePosition: "main",
        // 기본플레이어 활성화 여부
        basicPlayerVisiblity: false
    },
    mutations: {

    },
    actions: {

    }
});
